import {Box, Search} from "react-feather";
import {getClientProducts} from "global/slices/clients/thunks";
import {Header as HeaderComponent, Input, Row} from "components";
import {
  useAppDispatch,
  useAppSelector,
  useBreakpoints,
  useDebouncedSearch,
} from "hooks";

interface HeaderProps {}

export const Header: React.FC<HeaderProps> = () => {
  const dispatch = useAppDispatch();
  const {downXl, downMd} = useBreakpoints();
  const {clientProductsPagination} = useAppSelector("clients");
  const pagination = clientProductsPagination;
  const {setQuery} = useDebouncedSearch({
    onDebounce: (ser) =>
      dispatch(getClientProducts({...pagination, ser, pos: 0, refresh: true})),
    onEmptyQuery: () =>
      dispatch(
        getClientProducts({...pagination, pos: 0, ser: "", refresh: true})
      ),
  });

  return (
    <Row
      width="100%"
      marginBottom={10}
      gap={downMd ? 10 : 5}
      justifyContent="space-between"
      flexDirection={downXl ? "column" : "row"}
      alignItems={downXl ? "flex-start" : "center"}
    >
      <HeaderComponent icon={Box} children="Productos" />
      <Input
        icon={Search}
        placeholder="Buscar Producto"
        containerStyle={{marginBottom: 0, maxWidth: "350px"}}
        onChange={({target}) => {
          setQuery(target["value"]);
        }}
      />
    </Row>
  );
};
